// components/GlobalLoading.tsx
import { memo, useEffect, useState } from 'react'
import Lottie from 'lottie-react'
import animationData from '@/assets/loading.json'
import { useGobalLoading } from '@/hooks/useGobalLoading'
import './GlobalLoading.less'

const GlobalLoading = () => {
  const { visible, options, hide } = useGobalLoading()
  const [remainingTime, setRemainingTime] = useState<number | undefined>(options?.countdown)
  // 使用传入的动画数据，如果没有则使用默认的
  const currentAnimationData = options?.animationData || animationData

  useEffect(() => {
    if (!visible || !options?.countdown) {
      setRemainingTime(undefined)
      return
    }

    setRemainingTime(options.countdown)
  }, [visible, options?.countdown])

  useEffect(() => {
    if (remainingTime === undefined || remainingTime <= 0) {
      if (remainingTime === 0) {
        options?.onCountdownEnd?.()
      }
      return
    }
    const timer = setTimeout(() => {
      setRemainingTime(prev => (prev ?? 0) - 1)
    }, 1000)
    return () => clearTimeout(timer)
  }, [remainingTime, options])

  if (!visible) return null

  return (
    <div className='base-loading-container'>
      <div className='base-loading-inner'>
        <Lottie animationData={currentAnimationData} loop style={{ width: '100px', height: '100px' }} />
        <div className='loading-text'>
          {options?.closable && (
            <button
              onClick={() => {
                options.onCancle?.()
                hide()
              }}
            >
              停止生成
            </button>
          )}
          {typeof remainingTime === 'number' && (
            <p className='p2'>
              {remainingTime > 0 ? (
                <>
                  预计 <span>{remainingTime}</span>s 结束
                </>
              ) : (
                '已超时 请继续等待或取消重试'
              )}
            </p>
          )}
          {options?.text && <p style={{ marginTop: '10px' }}>{options.text}</p>}
        </div>
      </div>
    </div>
  )
}

export default memo(GlobalLoading)
